import { Link } from "react-router-dom";

const AboutBtn = ({ id }: { id: number }) => {
  return (
    <div className="sticky top-[82px] md:top-20 xl:top-32 left-0 w-full h-fit bg-light pt-3.5 px-2 z-10">
      <div className="relative w-full h-fit max-w-screen-lg mx-auto text-center grid grid-cols-3 xl:gap-14">
        <Link
          to={"/about/company"}
          type="button"
          className={
            id === 0
              ? "relative lg:px-8 w-full h-full border-b-8 border-font"
              : "pb-3"
          }
        >
          <p>회사현황</p>
        </Link>
        <Link
          to={"/about/history"}
          type="button"
          className={
            id === 1
              ? "relative lg:px-8 w-full h-full border-b-8 border-font"
              : "pb-3"
          }
        >
          <p>회사연혁&nbsp;및&nbsp;업력</p>
        </Link>
        <Link
          to={"/about/organization"}
          type="button"
          className={
            id === 2
              ? "relative lg:px-8 w-full h-full border-b-8 border-font"
              : "pb-3"
          }
        >
          <p>조직구성도</p>
        </Link>
      </div>
    </div>
  );
};

export default AboutBtn;
